(function () {

  /* =========================================================
     GLOBAL SETTINGS
  ========================================================= */

  var REVEAL_THRESHOLD = 0.15;

  /*
   * Repeat elements registered by the different sections.
   */
  var repeatElements = [];


  /*
   * One shared observer.
   */
  var revealObserver = null;


  /*
   * requestAnimationFrame state for reset checking.
   */
  var resetFrameRequested = false;



  /* =========================================================
     CREATE REVEAL OBSERVER
  ========================================================= */

  function createRevealObserver() {

    if (revealObserver) {
      return revealObserver;
    }


    revealObserver =
      new IntersectionObserver(

        function (entries) {

          entries.forEach(
            function (entry) {

              var element =
                entry.target;



              /* =================================================
                 ONLY HANDLE REVEAL HERE

                 IMPORTANT:
                 We deliberately DO NOT reset anything here.

                 This prevents threshold changes from causing
                 the element to animate backwards.
              ================================================= */

              if (
                entry.isIntersecting &&
                entry.intersectionRatio >= REVEAL_THRESHOLD
              ) {

                /*
                 * Make sure an old reset state has gone.
                 */

                element.classList.remove(
                  'ds-reveal-resetting'
                );


                /*
                 * Reveal.
                 */

                element.classList.add(
                  'is-revealed'
                );



                /* ===============================================
                   ONE-TIME ANIMATION
                =============================================== */

                if (
                  element.dataset.revealRepeat !== 'true'
                ) {

                  revealObserver.unobserve(
                    element
                  );

                }

              }

            }
          );

        },

        {
          root: null,


          /*
           * Multiple thresholds give more reliable callbacks
           * while entering.
           */

          threshold: [
            0,
            REVEAL_THRESHOLD,
            0.5
          ],


          /*
           * Retain roughly your existing trigger timing.
           */

          rootMargin:
            '0px 0px -8% 0px'
        }

      );


    return revealObserver;

  }



  /* =========================================================
     REGISTER REPEAT ELEMENT
  ========================================================= */

  function registerRepeatElement(
    element
  ) {

    if (
      repeatElements.indexOf(
        element
      ) !== -1
    ) {
      return;
    }


    repeatElements.push(
      element
    );

  }



  /* =========================================================
     RESET REPEAT ELEMENTS

     This is deliberately separate from IntersectionObserver.

     An element resets only when it is safely outside the
     physical viewport.

     Example:

        VIEWPORT
     ┌───────────────┐
     │               │
     │               │
     │               │
     └───────────────┘

             ↓
             ↓
        reset buffer
             ↓
          ELEMENT

     Only at that point do we return it to the hidden state.
  ========================================================= */

  function checkRepeatResets() {

    resetFrameRequested =
      false;


    var viewportHeight =
      window.innerHeight ||
      document.documentElement.clientHeight;



    repeatElements =
      repeatElements.filter(
        function (element) {

          /*
           * Shopify customizer may remove old sections.
           */

          if (
            !element ||
            !element.isConnected
          ) {

            return false;

          }



          /*
           * If it hasn't revealed yet,
           * there's nothing to reset.
           */

          if (
            !element.classList.contains(
              'is-revealed'
            )
          ) {

            return true;

          }



          var rect =
            element.getBoundingClientRect();



          /* =================================================
             GET THIS ELEMENT'S REVEAL DISTANCE

             Example:
             data-reveal-distance="70"

             We use the distance to calculate a safe reset
             zone so returning to its translated position
             cannot jump back into the viewport.
          ================================================= */

          var revealDistance =
            parseFloat(
              element.dataset.revealDistance
            ) || 70;



          /*
           * Minimum 120px buffer.
           *
           * For larger animations we automatically increase
           * the buffer.
           */

          var resetBuffer =
            Math.max(
              120,
              revealDistance + 50
            );



          /* =================================================
             CHECK IF SAFELY OUTSIDE VIEWPORT
          ================================================= */

          var fullyAbove =
            rect.bottom <
            (0 - resetBuffer);


          var fullyBelow =
            rect.top >
            (
              viewportHeight
              +
              resetBuffer
            );



          if (
            !fullyAbove &&
            !fullyBelow
          ) {

            /*
             * Still close to / inside screen.
             *
             * DO NOTHING.
             */

            return true;

          }



          /* =================================================
             INSTANT RESET

             Disable transitions first so the user never sees
             the element animate backwards.
          ================================================= */

          element.classList.add(
            'ds-reveal-resetting'
          );


          element.classList.remove(
            'is-revealed'
          );



          /*
           * Force browser to apply the hidden state while
           * transitions are disabled.
           */

          void element.offsetHeight;



          /*
           * Restore transitions next frame.
           *
           * Element is already outside the viewport, so this
           * is invisible to the visitor.
           */

          window.requestAnimationFrame(
            function () {

              if (
                element &&
                element.isConnected
              ) {

                element.classList.remove(
                  'ds-reveal-resetting'
                );

              }

            }
          );


          return true;

        }
      );

  }



  /* =========================================================
     REQUEST RESET CHECK

     Scroll can fire many times per second.

     requestAnimationFrame ensures that we only calculate
     once per browser frame.
  ========================================================= */

  function requestResetCheck() {

    if (resetFrameRequested) {
      return;
    }


    resetFrameRequested =
      true;


    window.requestAnimationFrame(
      checkRepeatResets
    );

  }



  /* =========================================================
     INITIALISE REVEALS
  ========================================================= */

  function initDoorstepReveal(
    root
  ) {

    root =
      root ||
      document;


    var elements =
      root.querySelectorAll(
        '.ds-scroll-reveal'
      );


    if (!elements.length) {
      return;
    }



    /* =====================================================
       FALLBACK
    ====================================================== */

    if (
      !(
        'IntersectionObserver'
        in
        window
      )
    ) {

      elements.forEach(
        function (element) {

          element.classList.add(
            'is-revealed'
          );

        }
      );


      return;

    }



    var observer =
      createRevealObserver();



    /* =====================================================
       INITIALISE EACH ELEMENT
    ====================================================== */

    elements.forEach(
      function (element) {


        /* =================================================
           ALREADY INITIALISED

           Still make sure repeat elements are registered.
        ================================================= */

        if (
          element.dataset.revealInitialized === 'true'
        ) {

          if (
            element.dataset.revealRepeat === 'true'
          ) {

            registerRepeatElement(
              element
            );

          }


          return;

        }



        element.dataset.revealInitialized =
          'true';



        /* =================================================
           DURATION
        ================================================= */

        if (
          element.dataset.revealDuration
        ) {

          element.style.setProperty(
            '--ds-reveal-duration',
            element.dataset.revealDuration
            +
            'ms'
          );

        }



        /* =================================================
           DELAY
        ================================================= */

        if (
          element.dataset.revealDelay
        ) {

          element.style.setProperty(
            '--ds-reveal-delay',
            element.dataset.revealDelay
            +
            'ms'
          );

        }



        /* =================================================
           DISTANCE
        ================================================= */

        if (
          element.dataset.revealDistance
        ) {

          element.style.setProperty(
            '--ds-reveal-distance',
            element.dataset.revealDistance
            +
            'px'
          );

        }



        /* =================================================
           REPEAT
        ================================================= */

        if (
          element.dataset.revealRepeat === 'true'
        ) {

          registerRepeatElement(
            element
          );

        }



        /* =================================================
           OBSERVE
        ================================================= */

        observer.observe(
          element
        );

      }
    );


    requestResetCheck();

  }



  /* =========================================================
     SCROLL

     IMPORTANT:
     The scroll handler DOES NOT directly change classes.

     It only schedules one reset calculation per frame.
  ========================================================= */

  window.addEventListener(
    'scroll',
    requestResetCheck,
    {
      passive: true
    }
  );



  /* =========================================================
     RESIZE
  ========================================================= */

  window.addEventListener(
    'resize',
    requestResetCheck
  );



  /* =========================================================
     NORMAL PAGE LOAD
  ========================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initDoorstepReveal(
          document
        );

      }
    );

  } else {

    initDoorstepReveal(
      document
    );

  }



  /* =========================================================
     SHOPIFY CUSTOMIZER
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initDoorstepReveal(
        event.target
      );


      requestResetCheck();

    }
  );

})();